import React from "react";
import styled from "styled-components";

const ProfileModal = ({ modal, setModal }) => {
  if (!modal?.state) return null;

  return (
    <>
      <Overlay onClick={() => setModal({ state: false })} />
      <ModalContainer>
        <CloseButton onClick={() => setModal({ state: false })}>✕</CloseButton>

        <ModalContent>
          {/* Profile Image Section */}
          <ImageWrapper>
            <ProfileImage
              src={modal?.metaData.image}
              alt={modal?.metaData.name}
            />
          </ImageWrapper>

          {/* Profile Info Section */}
          <InfoWrapper>
            <ProfileName>{modal?.metaData.name}</ProfileName>

            <Divider />

            <Description>{modal?.metaData.description}</Description>

            <InfoGrid>
              <InfoItem>
                <Label>Qualification</Label>
                <Value>{modal?.metaData.qualification}</Value>
              </InfoItem>

              <InfoItem>
                <Label>Experience</Label>
                <Value>{modal?.metaData.yearsOfExperience}</Value>
              </InfoItem>

              <InfoItem>
                <Label>Affiliated Organisation</Label>
                <Value>{modal?.metaData.affiliatedOrganisation}</Value>
              </InfoItem>

              <InfoItem>
                <Label>Languages Known</Label>
                <Value>
                  {modal?.metaData.languagesKnown &&
                  typeof modal?.metaData.languagesKnown != "string"
                    ? modal?.metaData.languagesKnown.join(", ")
                    : modal?.metaData.languagesKnown}
                </Value>
              </InfoItem>

              <InfoItem>
                <Label>Location</Label>
                <Value>{modal?.metaData.location}</Value>
              </InfoItem>

              <InfoItem>
                <Label>Specialities</Label>
                <Value>{modal?.metaData.areasOfExpertise}</Value>
              </InfoItem>

              {modal?.metaData.otherInterests && (
                <InfoItem>
                  <Label>Other Interests</Label>
                  <Value>{modal?.metaData.otherInterests}</Value>
                </InfoItem>
              )}
            </InfoGrid>
            <InfoGridOne>
              {modal?.metaData.chronicles && (
                <InfoItem>
                  <Label>Chronicles</Label>
                  <Value>{modal?.metaData.chronicles}</Value>
                </InfoItem>
              )}
            </InfoGridOne>
          </InfoWrapper>
        </ModalContent>
      </ModalContainer>
    </>
  );
};

export default ProfileModal;

// Styled Components

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(5px);
  z-index: 999;
  animation: fadeIn 0.3s ease;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

// const ModalContainer = styled.div`
//   position: fixed;
//   top: 55%;
//   left: 50%;
//   transform: translate(-50%, -50%);
//   background: white;
//   border-radius: 16px;
//   box-shadow: 0 25px 50px rgba(0, 0, 0, 0.3);
//   max-width: 700px;
//   width: 90%;
//   max-height: 90vh;
//   overflow-y: auto;
//   z-index: 1000;
//   animation: slideIn 0.3s ease;

//   @keyframes slideIn {
//     from {
//       transform: translate(-50%, -50%) scale(0.95);
//       opacity: 0;
//     }
//     to {
//       transform: translate(-50%, -50%) scale(1);
//       opacity: 1;
//     }
//   }

//   /* Scrollbar styling */
//   &::-webkit-scrollbar {
//     width: 8px;
//   }

//   &::-webkit-scrollbar-track {
//     background: #f1f1f1;
//     border-radius: 10px;
//   }

//   &::-webkit-scrollbar-thumb {
//     background: #00818a;
//     border-radius: 10px;

//     &:hover {
//       background: #006066;
//     }
//   }

//   @media (max-width: 768px) {
//     max-width: 95%;
//     width: 95%;
//     max-height: 85vh;
//     border-radius: 12px;
//   }

//   @media (max-width: 480px) {
//     max-width: 100%;
//     width: 100%;
//     max-height: 100vh;
//     border-radius: 20px 20px 0 0;
//     top: auto;
//     bottom: 0;
//     transform: translate(-50%, 0);
//   }
// `;

const ModalContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  max-width: 900px;
  background: #fff;
  border-radius: 16px;
  max-height: 90vh;
  overflow-y: auto;
  padding: 2rem;
  z-index: 1000;

  @media (max-width: 768px) {
    top: 0;
    left: 0;
    transform: none;
    height: 100vh;
    max-height: 100vh;
    border-radius: 0;
    padding-top: 3.5rem;
  }
`;



// const CloseButton = styled.button`
//   position: absolute;
//   top: 20px;
//   right: 20px;
//   background: white;
//   border: none;
//   cursor: pointer;
//   color: #666;
//   font-size: 28px;
//   font-weight: 300;
//   padding: 8px 12px;
//   border-radius: 50%;
//   transition: all 0.3s ease;
//   z-index: 1001;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   width: 44px;
//   height: 44px;
//   line-height: 1;
//   box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

//   &:hover {
//     background-color: #f5f5f5;
//     color: #00818a;
//     box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
//     transform: rotate(90deg);
//   }

//   @media (max-width: 480px) {
//     top: 16px;
//     right: 16px;
//     width: 40px;
//     height: 40px;
//     font-size: 24px;
//   }
// `;

const CloseButton = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  z-index: 1000;
  background: #fff;
  border: none;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  font-size: 1.4rem;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);

  @media (max-width: 768px) {
    top: 0.75rem;
    right: 0.75rem;
  }
`;



const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 28px;
  padding: 40px 32px;

  @media (max-width: 768px) {
    gap: 24px;
    padding: 32px 24px;
  }

  @media (max-width: 480px) {
    gap: 20px;
    padding: 28px 20px;
  }
`;

// const ImageWrapper = styled.div`
//   width: 100%;
//   display: flex;
//   justify-content: center;
//   align-items: center;
// `;

const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;

  img {
    width: 180px;
    height: 220px;
    object-fit: contain;
    border-radius: 12px;
  }

  @media (max-width: 768px) {
    img {
      width: 150px;
      height: 200px;
    }
  }
`;

const ProfileImage = styled.img`
  width: 240px;
  height: 240px;
  object-fit: cover;
  object-position: center;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  border: 4px solid #f9f9f9;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.02);
  }

  @media (max-width: 768px) {
    width: 200px;
    height: 200px;
  }

  @media (max-width: 480px) {
    width: 160px;
    height: 160px;
    border-radius: 10px;
  }
`;

const InfoWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  text-align: center;
`;

const ProfileName = styled.h2`
  font-size: 32px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0;
  line-height: 1.3;
  letter-spacing: -0.5px;

  @media (max-width: 768px) {
    font-size: 28px;
  }

  @media (max-width: 480px) {
    font-size: 24px;
  }
`;

const Divider = styled.div`
  width: 60px;
  height: 3px;
  background: linear-gradient(to right, #00818a, #00a8b3);
  border-radius: 2px;
  margin: 0 auto;
`;

const Description = styled.p`
  font-size: 14px;
  color: #555;
  line-height: 1.7;
  margin: 0;
  max-width: 100%;
  text-align: center;

  @media (max-width: 480px) {
    font-size: 13px;
    line-height: 1.6;
  }
`;

const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  width: 100%;
  margin-top: 12px;
  text-align: left;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    gap: 18px;
  }

  @media (max-width: 480px) {
    gap: 16px;
    margin-top: 8px;
  }
`;

const InfoGridOne = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  width: 100%;
  margin-top: 12px;
  text-align: left;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    gap: 18px;
  }

  @media (max-width: 480px) {
    gap: 16px;
    margin-top: 8px;
  }
`;

const InfoItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px;
  background: #f8f8f8;
  border-radius: 8px;
  transition: all 0.3s ease;
  border-left: 3px solid transparent;

  &:hover {
    background: #f0f0f0;
    border-left-color: #00818a;
  }

  @media (max-width: 480px) {
    padding: 10px;
    gap: 4px;
  }
`;

const Label = styled.span`
  font-size: 11px;
  font-weight: 700;
  color: #949ab0;
  text-transform: uppercase;
  letter-spacing: 0.8px;
`;

const Value = styled.span`
  font-size: 13px;
  color: #333;
  line-height: 1.6;
  font-weight: 500;

  @media (max-width: 480px) {
    font-size: 12px;
  }
`;
